module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn-form', {
    attrs: {
      "title": _vm.title,
      "listable": ""
    },
    on: {
      "close": function($event) {
        return _vm.cancel()
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function() {
        return [_c('v-btn', {
          attrs: {
            "disabled": !_vm.valid
          },
          on: {
            "click": _vm.send
          }
        }, [_vm._v("Отправить")])]
      },
      proxy: true
    }])
  }, [_c('v-card-text', [_c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Адреса эл. почты",
      "hint": "Введите адреса для рассылки документа",
      "rules": _vm.emailRules
    },
    model: {
      value: (_vm.to),
      callback: function($$v) {
        _vm.to = $$v
      },
      expression: "to"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Почтовый ящик",
      "hint": "Выберите ящик из которого будет осуществляться рассылка",
      "items": _vm.mailboxes,
      "item-value": "name",
      "item-text": "name"
    },
    model: {
      value: (_vm.mailbox),
      callback: function($$v) {
        _vm.mailbox = $$v
      },
      expression: "mailbox"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Тема",
      "hint": "Тема письма с сылкой на документ",
      "rows": "3"
    },
    model: {
      value: (_vm.subject),
      callback: function($$v) {
        _vm.subject = $$v
      },
      expression: "subject"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs5": "",
      "sm6": ""
    }
  }, [_c('v-select-check', {
    attrs: {
      "items": [{
        value: 'ATTACH',
        text: 'Прикрепить файлы',
        disabled: !_vm.model.uids
      }]
    },
    model: {
      value: (_vm.options),
      callback: function($$v) {
        _vm.options = $$v
      },
      expression: "options"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": "",
      "sm4": ""
    }
  }, [_c('v-date-field', {
    attrs: {
      "placeholder": "Сейчас"
    },
    model: {
      value: (_vm.scheduledDate),
      callback: function($$v) {
        _vm.scheduledDate = $$v
      },
      expression: "scheduledDate"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "sm2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "mask": "##:##",
      "rules": [function (v) { return !v || /^(2[0-3]|[01]?[0-9])([0-5]?[0-9])$/.test(v) || 'чч:мм'; }]
    },
    model: {
      value: (_vm.scheduledTime),
      callback: function($$v) {
        _vm.scheduledTime = $$v
      },
      expression: "scheduledTime"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-html-field', {
    attrs: {
      "value": this.text,
      "heightEditor": _vm.calcHeightEditor(),
      "label": "Сообщение"
    },
    on: {
      "input": _vm.setText
    }
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c7f5534","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/EmailForm.vue
// module id = 889
// module chunks = 1